/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSubscriptionUsage200ResponseIntegratedTabs
 */
export interface GetSubscriptionUsage200ResponseIntegratedTabs {
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionUsage200ResponseIntegratedTabs
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionUsage200ResponseIntegratedTabs
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionUsage200ResponseIntegratedTabs
     */
    max: number;
}

/**
 * Check if a given object implements the GetSubscriptionUsage200ResponseIntegratedTabs interface.
 */
export function instanceOfGetSubscriptionUsage200ResponseIntegratedTabs(value: object): value is GetSubscriptionUsage200ResponseIntegratedTabs {
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    return true;
}

export function GetSubscriptionUsage200ResponseIntegratedTabsFromJSON(json: any): GetSubscriptionUsage200ResponseIntegratedTabs {
    return GetSubscriptionUsage200ResponseIntegratedTabsFromJSONTyped(json, false);
}

export function GetSubscriptionUsage200ResponseIntegratedTabsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubscriptionUsage200ResponseIntegratedTabs {
    if (json == null) {
        return json;
    }
    return {
        
        'price': json['price'],
        'count': json['count'],
        'max': json['max'],
    };
}

export function GetSubscriptionUsage200ResponseIntegratedTabsToJSON(json: any): GetSubscriptionUsage200ResponseIntegratedTabs {
    return GetSubscriptionUsage200ResponseIntegratedTabsToJSONTyped(json, false);
}

export function GetSubscriptionUsage200ResponseIntegratedTabsToJSONTyped(value?: GetSubscriptionUsage200ResponseIntegratedTabs | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'price': value['price'],
        'count': value['count'],
        'max': value['max'],
    };
}

